export default {
    "accountValidateMsg" : "帳號必須為6-30位元字元，包括字母、數位、“.”、“_”、“@”，第一位字元僅能為數位或字母。",
    "storeSuccess" : "儲值成功",
    "editAccountTips" : "請輸入有效帳號",
    "editPwdTips" : "請輸入有效密碼",
    "editRepeatPwdTips" : "請重複輸入密碼",
    "pwdRepeatTips" : "兩次密碼不匹配",
    "changePwdSucc" : "修改密碼成功",
    "bindEmail" : "綁定郵箱",
    "errorVrifyCodeTips" : "驗證碼錯誤",
    "slectQuessionTips" : "請選擇安全問題",
    "answerTips" : "請輸入答案",
    "twoAnswerTips" : "請選擇兩個您已經設置的安全問題，並輸入正確答案。",
    "realNameValidateTips" : "請輸入4~60位的真實姓名",
    "phoneValidateTips" : "請輸入6～18位元數位的電話號碼",
    "areaSelectTips" : "請選擇正確的國家地區",
    "iDCardValidataTips" : "請輸入1~60位的身份證號碼",
    "changeProfileSucc" : "資訊編輯成功",
    "editVrfCodeTips" : "請輸入驗證碼",
    "securityQuestionTips" : "請設置您的安全問題，提升您的帳號安全。當您忘記密碼時，可以通過回答安全問題快速重置密碼。",
    "validateQuessionTips" : "請選擇兩個不同的問題並進行認證，認證完成後便可重置安全問題。",
    "originPwd" : "請輸入舊密碼",
    "newPwd" : "請輸入新密碼",
    "changePwdSuccess" : "修改密碼成功，請手動重新登入帳號，防止資料丟失",
    "accountName" : "請輸入帳號名稱",
    "password" : "請輸入密碼",
    "repeatPassword" : "請再重複密碼",
    "findPwdTips" : "請輸入您需要找回密碼的帳號名稱",
    "submit" : "提交",
    "send" : "發送",
    "modify" : "修改",
    "haveAgree" : "我已同意",
    "and" : "和",
    "privacyPolicy" : "隱私權原則",
    "completeness" : "資料完成度:",
    "gender" : "性別",
    "male" : "男",
    "female" : "女",
    "birthday" : "生日",
    "phone" : "聯繫電話",
    "region" : "國家／地區",
    "ID" : "護照或身份證號碼",
    "accountSetting" : "帳號設置",
    "upgrade" : "帳號升級",
    "profile" : "個人資料",
    "changePassword" : "修改密碼",
    "securityQuestion" : "安全問題",
    "creatework_headerTitle" : "創建工單",
    "mylist_headerTitle" : "我的工單",
    "bindEmailTips" : "請認證一個您的常用郵箱，提升您的帳號安全。當您忘記密碼時，可通過此郵箱快速重置密碼。",
    "enterEmailVrfcationTips" : "請輸入收到的驗證碼",
    "cancel" : "取消",
    "bindTps" : "選擇帳戶綁定的方式可以讓你在數台設備中以您的帳號來進行遊戲!",
    "login" : "登入",
    "logout" : "登出",
    "bind" : "帳戶綁定",
    "feedback" : "問題回饋",
    "terms" : "相關條款",
    "tips" : "提示",
    "guestSwitchTips" : "您當前已經有遊客帳戶存在，登錄後當前遊客帳戶會丟失，請問確認要登錄嗎？",
    "register" : "註冊",
    "realName" : "真實姓名",
    "enterEmailTips" : "請輸入郵箱位址",
    "emailVAlidateMsg" : "郵箱格式錯誤",
    "editEmaileTips" : "請輸入郵箱",
    "checkServiceTips" : "請先閱讀並接受服務條款和隱私政策！",
    "brithdayValidateTips" : "請選擇正確的生日",
    "facebookValidateTips" : "請輸入1~60位的facebook帳號",
    "eritOriginPwdTips" : "請輸入原密碼",
    "submitSuccess" : "提交成功",
    "rebindEmail" : "修改郵箱",
    "bindEmailSuccess" : "您已成功綁定郵箱\$email</br>使用已綁定郵箱進行認證，認證完成便可重置郵箱。",
    "reSetSecurityQuessoon" : "您已經成功設置安全問題<br/><br/>選擇不同的問題並進行認證，認證完成後便可重置問題",
    "canotModifyTips" : "個人資料資訊提交後將不能更改，是否提交？",
    "rebindEmailTips" : "您的郵箱 \$email,請點擊獲取驗證碼並輸入您收到的驗證碼",
    "reGetVrfCode" : "獲取驗證碼",
    "findPwdWayTips" : "請選擇以下方式找回",
    "emailWay" : "通過安全郵箱找回",
    "emailWayTips" : "你將收到一封確認郵件，可以重新設置密碼。",
    "quessionWay" : "通過安全問題找回",
    "quessionWayTips" : "回答已經設置的安全問題，可以重新設置密碼。",
    "resetPwdBtn" : "重置密碼",
    "lastStep" : "上一步",
    "sendEmailTips" : "我們已經向您的認證郵箱\$email發送確認郵件。<br>請將您收到的驗證碼正確填入對話方塊中。",
    "setNewPwdTips" : "恭喜！<br>您可以重新設置密碼了，請在對話方塊中輸入您的新密碼吧！",
    "termsOfUse" : "服務條款",
    "creatework_create" : "工單類",
    "creatework_createHolder" : "請選擇類型",
    "creatework_title" : "標題",
    "creatework_titleHolder" : "請輸入標題",
    "creatework_detail" : "問題詳情",
    "creatework_detailHolder" : "請輸入200字以內的問題詳情",
    "creatework_uploadTips" : "只能上傳jpg/png格式檔，檔不能超過5mb",
    "creatework_selectBox_selectTile" : "問題類型",
    "creatework_goGame" : "返回遊戲",
    "creatework_history" : "工單歷史",
    "mylist_noYet" : "您還沒有任何工單記錄喔",
    "mywork_solved" : "問題已解決了？點我",
    "mywork_service" : "給客服評分",
    "mywork_messageHolder" : "請輸入新消息",
    "mywork_score" : "請選擇評分",
    "mywork_confirm" : "確認",
    "creatework_selectBox_selectList3" : "其他問題",
    "creatework_selectBox_selectList2" : "帳號問題",
    "creatework_gameHolder" : "請選擇遊戲",
    "creatework_serverHolder" : "請選擇伺服器",
    "contactService" : "聯繫客服",
    "creatework_game" : "遊戲：",
    "creatework_server" : "伺服器：",
    "creatework_role" : "角色：",
    "selectRoleName" : "請選擇角色",
    "creatework_noRole" : "還沒有創建角色",
    "creatework_noGame" : "遊戲列表為空",
    "creatework_noServer" : "伺服器列表為空",
    "termText" : "我已同意37GAMES平台",
    "backLogin" : "返回登錄",
    "creatework_roleHolder" : "請選擇角色後再訪問",
    "findPwdFailTips" : "您沒有設置安全問題和安全郵箱，無法通過這種方式找回，請聯繫客服。",
    "payMall" : "儲值商城",
    "selectPayment" : "選擇金額",
    "plzSelectPayWay" : "請選擇您的管道",
    "gainPlus" : "加碼",
    "gainMorePlus" : "加碼多多",
    "gainMostPlus" : "最高加碼",
    "plzSelectPayType" : "選擇儲值方式",
    "roleName" : "角色名",
    "payWay" : "支付管道",
    "plzSelectOtherWay" : "選擇其他支付管道",
    "payment" : "支付金額",
    "compensateTips" : "超出商品價值部分將額外補償\$gameCode給您",
    "extaGain" : "額外獲得",
    "gameGold" : "遊戲幣",
    "compensate" : "補償",
    "payWayPlus" : "管道加碼",
    "neddPay" : "需支付",
    "submitOrder" : "提交訂單",
    "screenshotTips" : "溫馨提示：截圖保存訂單資訊，後續遇到問題方便回饋哦！",
    "storeFail" : "儲值失敗",
    "storeFailTips" : "非常抱歉本次儲值失敗了，請您嘗試重新提交訂單，或通過客服工單聯繫我們",
    "storeAcceptance" : "受理中",
    "storeSuccessTips" : "儲值成功後通常在15MIN內到賬，請稍後於遊戲內查看",
    "orderNumber" : "訂單號",
    "buyProduct" : "儲值商品",
    "transactionAmount" : "交易金額",
    "failReason" : "失敗原因",
    "payOntherORder" : "再儲一筆",
    "reStore" : "重新儲值",
    "confirm" : "確定",
    "switch" : "帳號切換",
    "completeTips" : "請填寫您的個人資料， 以下資訊<mark class=\"yellowMarkC`olor\">填寫後將不允許修改</mark>.當您的帳號丟失或被盜用時，可通過向客服提供準確的個人資料資訊作為取回帳號的依據。",
    "creatework_selectBox_selectList0" : "遊戲問題",
    "creatework_selectBox_selectList1" : "支付問題",
    "creatework_selectBox_selectList4" : "翻譯問題",
    "mywork_solvedText" : "問題已解決",
    "browserPayErrBtnText" : "交易遇到問題",
    "browserPaySucBtnText" : "已完成支付",
    "browserPayingTips" : "您正在前往協力廠商平臺進行支付,<br/>完成支付後即可關閉此頁面。",
    "price_list_empty" : "無可選金額",
    "pointCardTips" : "注意：商品僅支援等於 \$paymentAmount 的 點卡購買",
    "forgetPwd" : "忘記密碼",
    "payCenter" : "平臺儲值中心",
    "willGet" : "您將獲得",
    "goods" : "商品",
    "discount" : "額外贈送",
    "payDiscount" : "支付補償",
    "payDiscountTips" : "超出商品價格將進行支付補償",
    "hasQuestionPlease" : "如有疑問，請",
    "pwdValidateMsg" : "密碼必須為6-20位元字元",
    "payWayPlusC" : "渠道贈送",
    "fwtk" : "服務條款",
    "yszc" : "隱私政策",
    "exchange" : "禮包碼兌換",
    "remember" : "記住我",
    "thirdInfo" : "帳號規則說明",
    "thirdInfoContent" : "請在遊戲內的用戶中心完成帳號綁定，再使用綁定的帳號進行登錄。",
    "unLink" : "暫不支持此方式",
    "favour" : "Bookmark",
    "goStoreTip" : "Please proceed to the payment page",
    "go" : "Go",
    "otherLogin" : "Other login methods",
    "qrCodeTip" : "Scan the QR code to get started!",
    "favourTip" : "Bookmark the page to play again later!",
    "share" : "Share",
    "landscapeTip" : "Please proceed in portrait mode",
    "leaveTip" : "Exit the game?",
    "selectRole" : "請選擇您要充值的角色",
    "selectMoney" : "請選擇想購買的道具",
    "seletGameInfoFirst" : "Please choose game",
    "lowerIE" : "",
    "linkTermText" : "",
    "download" : "",
    "favourAndDownloadTip" : "",
    "payReward" : "Recharge Reward",
    "hasEqualReward" : "Double bonus for both payment methods",
    "payBtnText" : "Payment",
    "storeHoaveReward" : "Recharge Bonus",
    "showMorePayWay" : "More Methods",
    "needPaymentCount" : "Amount",
    "orderDetail" : "Details",
    "selectPayWayPlz" : "Choose payment",
    "-" : "-"
}